import React from 'react';

import autoBind from 'react-autobind';

// import other components within the same project here

import Localization from "../../Localization.jsx"

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  TextField,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from '@material-ui/core';

import { withTheme } from '@material-ui/core/styles';

class CreateStageDialog extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      open: false,
      stageName: "",
      stageType: "photo",
      createStageId: -1,
    };
    autoBind(this);
  }

  handleClose() {
    this.setState({
      open: false,
    });
    this.state.open = false;
  }

  handleStageTypeChanged(e) {
    this.setState({
      stageType: e.target.value,
    });
    this.state.stageType = e.target.value;
  }

  stageNameChanged(e) {
    this.setState({
      stageName: e.target.value,
    });
    this.state.stageName = e.target.value;
  }

  createNewStageClicked() {
    if (this.validateInput()) {
      let requestObj = {};
      requestObj['stage_name'] = this.state.stageName.trim();
      requestObj['user_id'] = this.props.root.getMyUserId();
      requestObj['locale_id'] = this.props.parent.props.localeData['id'];
      this.props.root.refs.API.request("create_stage", requestObj, this.createStageOK, this.createStageFailed);
    }
  }

  createStageOK(res) {
    let stage_id = res.body['result'];

    this.setState({
      createStageId: stage_id,
    });
    this.state.createStageId = stage_id;

    // update the stage after creating
    var requestObj = {};
    requestObj['stage_id'] = stage_id;
    requestObj['stage_name'] = this.state.stageName.trim();
    requestObj['user_id'] = this.props.root.getMyUserId();
    requestObj['locale_id'] = this.props.parent.props.localeData['id'];
    requestObj['kind'] = this.convertStageTypeToValue(this.state.stageType);
    // if this is the first stage of this stage,
    // set the "is_entry" to be true
    if (this.props.parent.state.stageList.length == 0){
      requestObj['is_entry'] = 1;
    }
    else {
      requestObj['is_entry'] = 0;
    }
    this.props.root.refs.API.request("update_stage", requestObj, this.updateStageOK, this.updateStageFailed);
  }

  createStageFailed(err) {
    console.log("create stage failed");
  }

  updateStageOK(res) {
    this.props.root.addNotification(Localization.strings.CREATED);
    this.handleClose();
    this.props.parent.refresh(this.state.createStageId);
  }

  updateStageFailed(err) {
    console.log("update stage failed " + err);
  }

  validateInput() {
    let result = true;
    if (this.state.stageName.trim() == "") {
      result = false;
      this.props.root.addNotification("Stage name cannot be empty");
    }
    return result;
  }

  convertStageTypeToValue(type) {
    let result = 0;
    switch (type) {
      case "photo":
        result = 1;
        break;
      case "video":
        result = 0;
        break;
      default:
        break;
    }
    return result;
  }

  render() {
    return (
      <div>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          fullWidth={true}
          maxWidth={'sm'}
        >
          <DialogTitle>{Localization.strings.NEW_STAGE}</DialogTitle>
          <DialogContent>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} sm={2}>
                {Localization.strings.NAME}
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  value={this.state.stageName}
                  onChange={this.stageNameChanged}
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                {Localization.strings.MEDIA_TYPE}
              </Grid>
              <Grid item xs={12} sm={10}>
                <FormControl>
                  <RadioGroup
                    value={this.state.stageType}
                    onChange={this.handleStageTypeChanged}
                  >
                    <FormControlLabel
                      value="photo"
                      control={<Radio color="primary"/>}
                      label={Localization.strings.PHOTO_360}
                    />
                    <FormControlLabel
                      value="video"
                      control={<Radio color="primary"/>}
                      label={Localization.strings.VIDEO_360}
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={2}>
              </Grid>
              <Grid item xs={12} sm={10}>
                <div style={{color:this.props.theme.palette.primary.main, fontWeight:'bold'}}>
                  {Localization.strings.MEDIA_TYPE_WARNING}
                </div>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions style={{padding:'16px 24px'}}>
            <Button
              onClick={this.handleClose}
            >
              {Localization.strings.CANCEL}
            </Button>
            <Button
              color="primary"
              variant="contained"
              onClick={this.createNewStageClicked}
            >
              {Localization.strings.CREATE}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

export default withTheme(CreateStageDialog);
